"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useProcurementTemplateSave_1 = require("src/modules/documents/purchases/procurements/hooks/useProcurementTemplateSave");
const ErrorMessages_1 = tslib_1.__importDefault(require("src/components/errors/ErrorMessages"));
const Loading_1 = tslib_1.__importDefault(require("core/components/Loading"));
const TinymceField_1 = tslib_1.__importDefault(require("../../../../../components/Texts/TinymceField"));
const TemplateForm = (props) => {
    (0, useProcurementTemplateSave_1.useProcurementTemplateSave)({
        updateProcurementTemplate: props.updateProcurementTemplate,
        isTemplateFetched: props.isTemplateFetched,
        status: props.status,
        dirty: props.templateForm.dirty,
        content: props.templateForm.values.content,
        isCreator: props.isCreator
    });
    (0, react_1.useEffect)(() => {
        if (props.procurementId)
            props.getTemplate();
    }, [props.procurementId]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.isTemplateFetching
            ? ((0, jsx_runtime_1.jsx)("div", { className: 'card', style: { height: 400 }, children: (0, jsx_runtime_1.jsx)("div", { className: 'card-body', children: (0, jsx_runtime_1.jsx)(Loading_1.default, {}) }) })) :
            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ErrorMessages_1.default, { closeErrorMessage: props.closeErrorMessage, errors: props.errors }), (0, jsx_runtime_1.jsx)(TinymceField_1.default, { name: 'content', height: 500, value: props.templateForm.values.content, loading: props.loading, setFieldValue: props.templateForm.setFieldValue, preventUpdate: props.disabled || !props.updatePermission })] }) }));
};
exports.default = TemplateForm;
